import { render } from "./Request.vue?vue&type=template&id=a7197ff6&scoped=true&ts=true"
import script from "./Request.vue?vue&type=script&lang=ts"
export * from "./Request.vue?vue&type=script&lang=ts"

import "./Request.vue?vue&type=style&index=0&id=a7197ff6&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7197ff6"]])

export default __exports__